import { FeatureCollection } from "geojson";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import {
  BuildingTypes,
  DrawingModes,
  MapboxModes,
} from "../components/local/Maps/data/identifier";

// if user is authenticated => false else it is true
const authAtom = atom(false);

const darkModeAtom = atomWithStorage("darkMode", false);

const mapModeAtom = atom(MapboxModes.DEFAULT_MODE);

const infoBoxIsOpenAtom = atom(true);

const selectedFeaturesAtom = atom(0);

const drawingModesAtom = atom(DrawingModes.VIEW_MODE);

const buildUpTypeAtom = atom(BuildingTypes.UNCONSTRUCTED);

const initialRoofFeatures = atom<FeatureCollection>({
  type: "FeatureCollection",
  features: [],
});

const finalDrawingFeatureCollectionAtom = atom({});

const getHeightDialogAtom = atom(false);

const drawerOpenAtom = atom(false);

const currentPolygonSelectedAtom = atom("");

// for testing
const testAtom = atom(true);

export {
  authAtom,
  buildUpTypeAtom,
  currentPolygonSelectedAtom,
  darkModeAtom,
  drawerOpenAtom,
  drawingModesAtom,
  finalDrawingFeatureCollectionAtom,
  getHeightDialogAtom,
  infoBoxIsOpenAtom,
  initialRoofFeatures,
  mapModeAtom,
  selectedFeaturesAtom,
  testAtom,
};
